// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3trcV","location":"Header_location__3CQDK"};